export const SMALL_ROWS_PER_PAGE_OPTIONS = [5, 10];
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = '10';
export const DEFAULT_PAGE = '1';
